import { ActivatedRouteSnapshot } from '@angular/router';
import { BlogArticle } from '@shared/models/blog-article.model';
import { BlogService } from '../services/blog.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SearchTagsResolver  {
  constructor(
    private blogService: BlogService
  ) { }

  resolve(route: ActivatedRouteSnapshot): Observable<BlogArticle> | Promise<BlogArticle> | BlogArticle {
    return this.blogService.findArticlesByTerms(route.paramMap.get('terms'));
  }
}
